/**
 * A taxa do ativo chega como TEXTO pt-BR já montado ("110,0000% CDI"), nunca
 * como número: quem escreve as 4 casas é o próprio cadastro
 * (`asset-form-renda-fixa.vue` e irmãos usam `toFixed(4)`), e o indexador vem
 * colado. Por isso a limpeza é feita SOBRE A STRING, aparando só os zeros
 * supérfluos de cada decimal e preservando o resto verbatim: indexador, sinal,
 * separador de milhar e casas significativas continuam como estão.
 *
 * Só o separador decimal pt-BR (vírgula) é tratado. O ponto é separador de
 * milhar nessa origem, então mexer nele apagaria dígitos reais. E se a string
 * chegar no formato inglês (vírgula como milhar SEGUIDA de separador decimal,
 * `1,000.50%`), a função devolve ela intocada: aparar ali apagaria três dígitos
 * e erraria por mil vezes. `1,000%` sem casa decimal fica fora dessa guarda e
 * é lido como pt-BR, que é o comportamento certo para a origem deste campo.
 *
 * Por que não `splitTax` + `formatNumberZero` (`@utils/Format`), que existem e
 * fazem as duas metades: eles REMONTAM a string a partir do número e do
 * indexador, e aqui o requisito é preservar o texto verbatim (sufixo livre,
 * `a.a.`, segundo número, espaçamento). O que vale a pena herdar do `splitTax`
 * é a normalização `IPCA` para `IPC-A`, que o resto da plataforma já exibe
 * assim, e ela vem abaixo.
 */

const DECIMAL_PT_BR = /(\d+),(\d+)/g

const MILHAR_INGLES = /\d,\d{3}[.,]/

export const formatAssetTaxa = (taxa) => {
  if (!taxa || typeof taxa !== 'string') {
    return taxa
  }
  if (MILHAR_INGLES.test(taxa)) {
    return taxa
  }
  return taxa
    .replace('IPCA', 'IPC-A')
    .replaceAll(DECIMAL_PT_BR, (match, inteiro, decimal) => {
      const significativo = decimal.replace(/0+$/, '')
      return significativo ? `${inteiro},${significativo}` : inteiro
    })
}
